import { CLEAN_STRIPE, CLEAN_STRIPE_ERROR } from '_models/redux/types';

export const cleanStripeAction = () => async (dispatch) => {
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_STRIPE,
    });
  } catch (e) {
    dispatch({
      payload: undefined,
      type: CLEAN_STRIPE_ERROR,
    });
  }
};
